<template>
  <span class="label color-sachlich-black"><slot /></span>
</template>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';

.label {
  margin-left: 1px;
}
</style>
